import { createAsyncThunk } from '@reduxjs/toolkit';
import axiosInstance from '../../config/Axios/axios-instance';
import { JumpTaskEntryList } from '../../domain/JumpTaskEntry';
import { ListParams } from '../../hooks/useList/useList';

export const fetchJumpTaskList = createAsyncThunk('jumpTask/entryList', async (params?: ListParams) => {
  const response = await axiosInstance.get<JumpTaskEntryList>(`/jump-task-entry/all`, { params });
  return response.data;
});
